module.exports = __webpack_public_path__ + "static/media/catalogueImg10.8edc5847.png";